import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Config from '../../config';
var isNumber = function isNumber(val) {
  return val === parseInt(val, 10);
};
var getColumnWidthFromProps = function getColumnWidthFromProps(props) {
  return Object.keys(props).filter(function (propKey) {
    return ['xs', 'sm', 'md', 'lg', 'xl'].indexOf(propKey) !== -1;
  }).map(function (viewport) {
    // if prop is set to a fixed width (1-12)
    if (isNumber(props[viewport])) {
      return Config.media[viewport](_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            flex-basis: ", "%;\n            max-width: ", "%;\n            display: block;\n          "])), 100 / 12 * props[viewport], 100 / 12 * props[viewport]);
    } else if (props[viewport]) {
      // else if prop is set to true (auto sizing)
      return Config.media[viewport](_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            flex-grow: 1;\n            flex-basis: 0;\n            max-width: 100%;\n            display: block;\n          "])));
    } else {
      // else column is hidden
      return Config.media[viewport](_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["display: none"])));
    }
  });
};
var getColumnOffsetFromProps = function getColumnOffsetFromProps(props) {
  return Object.keys(props).filter(function (propKey) {
    return ['xsOffset', 'smOffset', 'mdOffset', 'lgOffset', 'xlOffset'].indexOf(propKey) !== -1;
  }).map(function (viewport) {
    return Config.media[viewport.replace(/Offset$/, '')](_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        margin-left: ", "%;\n      "])), 100 / 12 * props[viewport]);
  });
};
var Column = styled.div.withConfig({
  displayName: "Column",
  componentId: "sc-15sd1j8-0"
})(["box-sizing:border-box;flex:0 0 auto;padding:", "rem ", "rem;flex-direction:", ";", " ", ";", ";"], Config.grid.gutterWidth / 2, Config.grid.gutterWidth / 2, function (p) {
  return p.reverse ? 'column-reverse' : 'column';
}, function (p) {
  return getColumnWidthFromProps(p);
}, function (p) {
  return getColumnOffsetFromProps(p);
}, function (p) {
  return p.noGutter && "padding: 0;";
});
Column.defaultProps = {
  xs: true
};
Column.propTypes = {
  /** Reverse flex direction */
  reverse: PropTypes.bool,
  noGutter: PropTypes.bool,
  /**
   * When integer value, it specify the column size on the grid.
   * When true, enable auto sizing column.
   * When false, hide column for the breakpoint.
   */
  xs: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  sm: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  md: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  lg: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  xl: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  xsOffset: PropTypes.number,
  smOffset: PropTypes.number,
  mdOffset: PropTypes.number,
  lgOffset: PropTypes.number,
  xlOffset: PropTypes.number
};
export default Column;